import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, Ref, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  LoaderIndicator,
  Heading,
  HeadingDisplay,
  BaseText,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { RiskSelectionSlider } from '@/modules/common/components/RiskSelectionSlider';

import { getRisks, IRisk } from '@/modules/catalog/services/funds';
import { IRiskData } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'Risk',
  setup(__props) {

const router = useRouter();

const isLoading = inject('isLoading') as Ref<boolean>;
const data = inject('data') as Ref<IRiskData>;

const updateData = inject('updateData', (key: string, risk: object) => ({
  key,
  risk
}));

const isFetchingRisks = ref(true);
const risks = ref<IRisk[] | null>(null);
const selectedRisk = ref(1);

const risk = computed(() => {
  return risks.value![selectedRisk.value - 1];
});

const investorType = computed(() => {
  return data.value.profile ? data.value.profile.value : 'Common';
});

const riskSelected = computed(() => {
  return {
    value: risk.value.risk.value,
    formatted: risk.value.risk.formatted,
    id: risk.value.apiId
  };
});

const recommendedRisk = computed(() => {
  return risks.value!.findIndex(risk => risk.recommended) + 1 || 1;
});

function handleRiskChange(index: number) {
  selectedRisk.value = index;
}

function onClick() {
  updateData('risk', riskSelected.value);
}

async function fetchRisks() {
  try {
    isFetchingRisks.value = true;

    const params = data.value.period
      ? {
          investorType: investorType.value,
          period: data.value.period.value
        }
      : {
          investorType: investorType.value,
          type: data.value.type
        };

    risks.value = await getRisks(params);

    selectedRisk.value = recommendedRisk.value;
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível carregar as informações. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });

    router.push({ name: 'catalog' });
  } finally {
    isFetchingRisks.value = false;
  }
}

onMounted(async () => {
  await fetchRisks();
});

return { __sfc: true,router, isLoading, data, updateData, isFetchingRisks, risks, selectedRisk, risk, investorType, riskSelected, recommendedRisk, handleRiskChange, onClick, fetchRisks, LoaderIndicator, Heading, HeadingDisplay, BaseText, ButtonContainer, ButtonPrimary, NebraskaColors, RiskSelectionSlider }
}

})